export default function adminAjaxApi(data, callback) {
	//get url from body data-ajax
	var url = jQuery('body').data('ajax');
	jQuery.ajax({
		url: url,
		method: 'POST',
		data: {...data, ...{gumnut_nonce:window.tccdata.nonce}},
		dataType: 'json',
		success: callback,
		error: function() {
			console.log('error');
			console.log(url);
			// window.location = '/my-account';
		}
	});
}
